﻿<script>
	import model from "../stores/modelStore";
	import { pageNumber, currentPage } from "../stores/pageStore";

	import PageSection from "../components/PageSection.svelte";
	import ThankYouSurveyComplete from "../components/ThankYouSurveyComplete.svelte";
	import ThankYouScreenOut from "../components/ThankYouScreenOut.svelte";

	window.onbeforeunload = null;

	$pageNumber = ($currentPage ? $currentPage.pageIndex : 0);

</script>

<PageSection>
	{#if $model.GeneralInformationScreenOut}
		<ThankYouScreenOut></ThankYouScreenOut>
	{:else if $model.FundDetailsScreenOut}
		<ThankYouScreenOut></ThankYouScreenOut>
	{:else}
		<ThankYouSurveyComplete></ThankYouSurveyComplete>
	{/if}
</PageSection>
